import { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import BackToTop from "@/components/feature/BackToTop";
import PageHeader from "@/components/feature/PageHeader";
import { faqs } from "@/mocks/comics";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqJsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <div className="min-h-screen bg-background-50">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }} />

      <Navbar />
      <main>
        <PageHeader
          crumbs={[{ label: "首页", to: "/" }, { label: "常见问题" }]}
          title="常见问题"
          subtitle="关于榜单计算、分类推荐、投稿反馈等疑问，这里都有答案。没有找到你的问题？随时联系我们。"
        />

        <div className="mx-auto max-w-4xl px-4 md:px-6 py-10 md:py-14">
          <div className="flex flex-col gap-3">
            {faqs.map((f, i) => {
              const open = openIndex === i;
              return (
                <div key={i} className="rounded-lg bg-background-100 border border-background-300/50 overflow-hidden">
                  <button
                    type="button"
                    onClick={() => setOpenIndex(open ? null : i)}
                    className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
                    aria-expanded={open}
                  >
                    <span className="text-sm md:text-base font-semibold text-foreground-950">{f.q}</span>
                    <i className={`${open ? "ri-subtract-line text-primary-400" : "ri-add-line text-foreground-600"} shrink-0 text-lg transition-transform`}></i>
                  </button>
                  {open && (
                    <p className="px-5 pb-4 text-sm leading-relaxed text-foreground-600">{f.a}</p>
                  )}
                </div>
              );
            })}
          </div>

          {/* 没有找到答案 */}
          <div className="mt-10 rounded-lg bg-primary-500/10 border border-primary-500/30 p-8 text-center">
            <i className="ri-chat-smile-3-line text-4xl text-primary-400"></i>
            <h2 className="mt-3 font-heading text-xl md:text-2xl text-foreground-950">还有疑问没解决？</h2>
            <p className="mt-2 text-sm text-foreground-600">
              如果你对排行榜、分类推荐或投稿有更多想法，欢迎通过邮箱联系我们，我们会尽快回复。
            </p>
            <div className="mt-5 flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link to="/recommend" className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-2.5 text-sm font-semibold text-background-50 hover:bg-primary-600 transition-colors">
                去逛爽漫推荐
              </Link>
              <span className="inline-flex items-center gap-2 text-sm text-foreground-700">
                <i className="ri-mail-line text-primary-400"></i>contact@paozhamanhua.com
              </span>
            </div>
          </div>
        </div>
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}